// extracted by mini-css-extract-plugin
module.exports = {"root":"AllMerch_root__aTPdB"};